import React, { useState, useEffect } from "react";
import { Chart } from "react-google-charts";
import config from "../config/config";

const options = {
  chart: {
    title: "Company Performance",
    subtitle: "Purchases and Earnings over the Months",
  },
};

function Barchart() {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    // Fetch the API data
    fetch(`${config.baseUrl}/Report/GetMonthProfit`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // Transform the API response to match the chart data structure
        const formattedData = [
          ["Month", "Purchases", "Earnings"],
          ...data.map((item) => [
            item.month,
            item.purchase,
            item.earnings,
          ]),
        ];
        setChartData(formattedData);
      })
      .catch((error) => console.error("Error fetching API data:", error));
  }, []);

  // Render the chart only when data is available
  return (
    <div>
      {chartData.length > 0 ? (
        <Chart
          chartType="Bar"
          data={chartData}
          options={options}
          height={"400px"}
        />
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
}

export default Barchart;
